// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackNewShippingInfoSetParameters extends TrackEventBaseParameters {}

const trackNewShippingInfoSet = (
    parameters: TrackNewShippingInfoSetParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "new_shipping_info_set", ...parameters }, options);
};

export default trackNewShippingInfoSet;
